/* eslint-disable max-lines */
export const defaultSettings = {
  general: {
    sidebar: {
      isOpen: true
    }
  },
  clinicalNote: {
    hp: {
      enabled: true
    },
    soap: {
      enabled: true
    },
    dap: {
      enabled: false
    },
    mha: {
      enabled: false
    },
    epn: {
      enabled: false
    },
    chart3d: {
      enabled: false
    },
    attachments: {
      enabled: true
    },
    myscribe: {
      enabled: false
    },
    vitals: {
      enabled: true
    },
    treatment_plan: {
      enabled: true
    },
    overview: {
      enabled: true,
      vitals: true,
      allergies: true,
      medications: true,
      weight_loss_administration: false,
      vaccines: true,
      alerts: true,
      conditions: true,
      medical_history: true,
      family_history: true,
      social_history: true,
      surgical_history: true,
      growth_chart: false
    },
    macros: {
      enabled: true
    },
    auto_save: {
      enabled: true
    },
    toggleLSidebar: {
      enabled: true
    },
    toggleRSidebar: {
      enabled: false
    },
    templateView: {
      type: 'single',
      advancedTemplate: false
    },
    sections: {
      hp: {
        generalHistory: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        complaints: { enabled: true, position: null, advancedForm: true, category: 'history' },
        hpi: { enabled: true, position: null, advancedForm: true, category: 'history' },
        ros: { enabled: true, position: null, advancedForm: true, category: 'history' },
        medications: { enabled: true, position: null, advancedForm: true, category: 'history' },
        vaccines: { enabled: true, position: null, advancedForm: true, category: 'history' },
        allergies: { enabled: true, position: null, advancedForm: true, category: 'history' },
        socialHistory: { enabled: true, position: null, advancedForm: true, category: 'history' },
        familyHistory: { enabled: true, position: null, advancedForm: true, category: 'history' },
        medicalHistory: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        surgicalHistory: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        test: { enabled: true, position: null, advancedForm: true, category: 'history' },
        weightLossAdministration: {
          enabled: false,
          position: null,
          advancedForm: true,
          category: 'history'
        },
        notes: { enabled: true, position: null, category: 'history' },
        exam: { enabled: true, position: null, advancedForm: true, category: 'physical' },
        vitals: { enabled: true, position: null, advancedForm: true, category: 'physical' },
        diagnosisCodes: { enabled: true, position: null, category: 'assessment' },
        assessment: { enabled: true, position: null, advancedForm: true, category: 'assessment' },
        plan: { enabled: true, position: null, advancedForm: true, category: 'plan' },
        cptCodes: { enabled: true, position: null, category: 'plan' },
        orders: { enabled: true, position: null, category: 'plan' }
      },
      intake: {
        patientNeeds: { enabled: true, position: null },
        problemManifestationDefinition: { enabled: true, position: null },
        diagnosisCodes: { enabled: true, position: null },
        goals: { enabled: true, position: null },
        timeFrames: { enabled: true, position: null },
        vitals: { enabled: true, position: null },
        riskAndCoMorbidities: { enabled: true, position: null },
        cptCodes: { enabled: true, position: null },
        notes: { enabled: true, position: null },
        orders: { enabled: true, position: null }
      },
      soap: {
        subjective: { enabled: true, position: null, category: 'subjective' },
        medications: {
          enabled: true,
          position: null,
          advancedForm: true,
          category: 'subjective'
        },
        patientNeeds: { enabled: false, position: null, category: 'subjective' },
        problemManifestationDefinition: {
          enabled: false,
          position: null,
          category: 'subjective'
        },
        notes: { enabled: true, position: null, category: 'subjective' },
        objective: { enabled: true, position: null, category: 'objective' },
        vitals: { enabled: true, position: null, category: 'objective' },
        assessment: { enabled: true, position: null, category: 'assessment' },
        diagnosisCodes: { enabled: true, position: null, category: 'assessment' },
        plan: { enabled: true, position: null, category: 'plan' },
        cptCodes: { enabled: true, position: null, category: 'plan' },
        goals: { enabled: false, position: null, category: 'plan' },
        orders: { enabled: true, position: null, category: 'plan' }
      },
      progress: {
        goals: { enabled: true, position: null, advancedForm: true },
        session: { enabled: true, position: null, advancedForm: true },
        riskFactors: { enabled: true, position: null, advancedForm: true },
        sessionQuotesAndContents: { enabled: true, position: null, advancedForm: true },
        activeSymptoms: { enabled: true, position: null, advancedForm: true },
        functionalImpairment: { enabled: true, position: null, advancedForm: true },
        interventions: { enabled: true, position: null, advancedForm: true },
        vitals: { enabled: true, position: null, advancedForm: true },
        progress: { enabled: true, position: null, advancedForm: true },
        cptCodes: { enabled: true, position: null, advancedForm: true },
        diagnosisCodes: { enabled: true, position: null, advancedForm: true },
        notes: { enabled: true, position: null },
        orders: { enabled: true, position: null }
      },
      myscribe: {
        recordVisit: { enabled: true, position: null },
        transcript: { enabled: true, position: null }
      }
    }
  },
  appointmentFilters: {
    appointmentType: [],
    appointmentStatus: [],
    appointmentConfirmState: [],
    serviceType: [],
    patient: [],
    practitioners: [],
    selectedView: null
  },
  formBuilder: {
    auto_save: {
      enabled: false
    }
  },
  appointment: {
    details: {
      isOpen: true,
      isPined: false
    },
    pricing: {
      isOpen: true,
      isPined: false,
      showConfirmations: {
        selfPay: true
      }
    },
    timeline: {
      isOpen: true,
      isPined: false
    },
    isNew: false,
    isConfirmationPins: true
  },
  patientChartTags: {
    isPinned: false,
    showConfirmations: {
      pin: true,
      unpin: true,
      remove: true
    }
  }
};

export const defaultPracticeSettings = {
  products: true,
  packages: true,
  tax: true
};

export const checkinSteps = {
  demographics: true,
  signature: true,
  hipaa: true,
  custom_forms: true,
  personal_id: true,
  insurance: true,
  payment: true
};

export const selfScheduling = {
  show_services: true,
  show_service_price: false,
  default_service_id: null,
  payment: {
    payment_requirement: 'none',
    card_charge_timing: 'day_of',
    card_charge_time: '05:00'
  }
};

export const chartLinks = [
  { label: 'Overview', path: '', icon: 'health-mono', end: true },
  {
    label: 'Demographics',
    path: 'demographics',
    permission: 'patients.read',
    icon: 'note-text-1-mono'
  },
  {
    label: 'Appointments',
    path: 'appointments',
    permission: 'appointments.read',
    icon: 'calendar-2-mono'
  },
  {
    label: 'Clinical Notes',
    path: 'clinical-notes',
    permission: 'clinical_note.read',
    icon: 'note-mono'
  },
  {
    label: 'ePrescribe',
    path: 'eprescribe',
    permission: 'prescribe.read',
    icon: 'prescribe-mono'
  },
  {
    label: 'History',
    path: 'history',
    permission: 'patients_medical_history.read',
    icon: 'document-text-mono'
  },
  {
    label: 'Billing',
    path: 'billing',
    permission: 'billing.read',
    icon: 'billing-mono',
    children: [
      {
        label: 'Transactions',
        path: 'billing',
        permission: 'billing.read',
        icon: 'billing-mono'
      },
      {
        label: 'Superbills',
        path: 'billing/superbill',
        permission: 'billing.read',
        icon: 'billing-mono'
      },
      {
        label: 'Claims',
        path: 'billing/claims',
        permission: 'billing.read',
        icon: 'wallet-mono'
      },
      {
        label: 'Ledger',
        path: 'billing/ledger',
        permission: 'billing.read',
        icon: 'macro-mono'
      },
      {
        label: 'Invoices',
        path: 'billing/invoices',
        permission: 'billing.read',
        icon: 'file-invoice-mono'
      }
    ]
  },
  {
    label: 'Communications',
    path: 'communications',
    permission: 'patient_communication.read',
    icon: 'messages-mono'
  },
  {
    label: 'Documents',
    path: 'documents',
    permission: 'patient_documents_center.read',
    icon: 'document-text-mono'
  },
  { label: 'Account', path: 'account', icon: 'profile-mono' }
];
